module.exports = __webpack_public_path__ + "img/d_02.3e65a268.png";